export interface Breadcrumb {
  title: string;
  href?: string;
  routerLink?: string;
}
